import { render, staticRenderFns } from "./platformMoneyV2.vue?vue&type=template&id=28083774"
import script from "./platformMoneyV2.vue?vue&type=script&lang=js"
export * from "./platformMoneyV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports